export default __webpack_public_path__ + "static/media/forklift_6414339.ef35ec21.png";